// ErrorPage.js
import React from 'react'
import { useTranslation } from 'react-i18next'
import './ErrorPage.css'

const ErrorPage = ({ error }) => {
  const { t } = useTranslation('error')

  return (
    <div className="error-container">
      <img
        src="https://designbanken.riktigspor.no/wp-content/uploads/2022/05/lovLovold-6.png"
        alt="Logo"
        className="logo"
      />
      <div className="error-content">
        <h1 style={{ color: '#00304A' }}>{t('errorTitle')}</h1>
        <p>{t('errorMessage')}</p>
        <p>{error}</p>
      </div>
    </div>
  )
}

export default ErrorPage
